import React from "react";
import content from 'content.json';

function Features() {
  return (
    <div className="content">
      {/* Hero Section */}
      <div className="hero-section">
        <h1>Monitor Your Indoor Air Quality</h1>
        <p>
          Seamlessly connects with your Netatmo account to track and analyze
          average PPM levels during the night for healthier living spaces.
        </p>
        <a href="#/admin/getactivities" className="btn-airiq" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Get Started
        </a>
      </div>

      {/* Video Section */}
      <div className="video-container">
        <iframe
          width="100%"
          height="480"
          src="https://www.youtube.com/embed/jdpLdmoKcCo"
          title="IndoorAirIQ Demo"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>

      {/* Features Section */}
      <div style={{ marginBottom: '48px' }}>
        <h2 className="section-heading gradient-text">Features</h2>
        <p className="section-subheading">Everything you need to understand your indoor air quality</p>
        <div className="feature-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-home"></i>
            </div>
            <h3>Room Selection</h3>
            <p>Choose specific rooms to monitor and track air quality across your entire home.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-chart-bar"></i>
            </div>
            <h3>Daily Air Quality Report</h3>
            <p>View the average PPM levels from the previous night at a glance.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-exchange-alt"></i>
            </div>
            <h3>Comparison Feature</h3>
            <p>Compare last night's air quality with the night before for insights into trends.</p>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div style={{ marginBottom: '48px' }}>
        <h2 className="section-heading gradient-text">Benefits</h2>
        <p className="section-subheading">Why tracking indoor air quality matters</p>
        <div className="feature-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-heartbeat"></i>
            </div>
            <h3>Improved Health Awareness</h3>
            <p>Helps ensure healthier sleep environments by keeping you informed of air quality during the night.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-th-large"></i>
            </div>
            <h3>Easy Room-by-Room Tracking</h3>
            <p>Gain insights into air quality across different rooms in your home.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <i className="fas fa-lightbulb"></i>
            </div>
            <h3>Actionable Insights</h3>
            <p>Understand trends and changes in air quality, helping you take steps to improve it.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Features;
